/**
 * 本文件由 scripts/generate-spm-codes.mjs 生成，请勿手改；编码以评审确认后的 CSV 快照为准。
 * 页面终端：home_pc（360 个 D 位坑位，19 个 C 位模块）。
 * 模块级曝光上报 module.code（A.B.C）；坑位级曝光与点击上报完整编码（A.B.C.D）。
 * 首页楼层的分组键仅用于选择模板，C 段统一为 {component_id}_{id}；全局模块保留固定 C 段。
 * 楼层模板需绑定实际 component_id/id 后使用；运行时由 useHomeSpmModuleCode 生成实际模块码，不能直接上报占位符。
 */
import type { SpmPageCodes } from '../types';
import { getSpmSitePrefix } from '../site';

const sitePrefix = getSpmSitePrefix();

export const HOME_PC_SPM_CODES = {
  best_sellers: {
    code: `${sitePrefix}.home_pc.{component_id}_{id}`,
    next: `${sitePrefix}.home_pc.{component_id}_{id}.next`,
    open_featured_product: `${sitePrefix}.home_pc.{component_id}_{id}.open_featured_product`,
    previous: `${sitePrefix}.home_pc.{component_id}_{id}.previous`,
    select_next_product: `${sitePrefix}.home_pc.{component_id}_{id}.select_next_product`,
    select_previous_product: `${sitePrefix}.home_pc.{component_id}_{id}.select_previous_product`,
    shop_featured_product: `${sitePrefix}.home_pc.{component_id}_{id}.shop_featured_product`,
    'tab_option_{NN}': `${sitePrefix}.home_pc.{component_id}_{id}.tab_option_{NN}`,
    view_more: `${sitePrefix}.home_pc.{component_id}_{id}.view_more`,
  },
  eyewear_inspiration: {
    code: `${sitePrefix}.home_pc.{component_id}_{id}`,
    'color_swatch_{NNN}_{NN}': `${sitePrefix}.home_pc.{component_id}_{id}.color_swatch_{NNN}_{NN}`,
    'favorite_{NNN}': `${sitePrefix}.home_pc.{component_id}_{id}.favorite_{NNN}`,
    next: `${sitePrefix}.home_pc.{component_id}_{id}.next`,
    open_campaign: `${sitePrefix}.home_pc.{component_id}_{id}.open_campaign`,
    previous: `${sitePrefix}.home_pc.{component_id}_{id}.previous`,
    'product_{NNN}': `${sitePrefix}.home_pc.{component_id}_{id}.product_{NNN}`,
  },
  footer_country_sites: {
    code: `${sitePrefix}.home_pc.footer_country_sites`,
    'country_site_entry_{NNN}': `${sitePrefix}.home_pc.footer_country_sites.country_site_entry_{NNN}`,
  },
  footer_help: {
    code: `${sitePrefix}.home_pc.footer_help`,
    open_contact_us: `${sitePrefix}.home_pc.footer_help.open_contact_us`,
    open_market_zeelool_com: `${sitePrefix}.home_pc.footer_help.open_market_zeelool_com`,
    open_track_order: `${sitePrefix}.home_pc.footer_help.open_track_order`,
  },
  footer_navigation: {
    code: `${sitePrefix}.home_pc.footer_navigation`,
    'footer_link_{NN}': `${sitePrefix}.home_pc.footer_navigation.footer_link_{NN}`,
  },
  footer_policies: {
    code: `${sitePrefix}.home_pc.footer_policies`,
    'policy_entry_{NN}': `${sitePrefix}.home_pc.footer_policies.policy_entry_{NN}`,
  },
  footer_social: {
    code: `${sitePrefix}.home_pc.footer_social`,
    'social_entry_{NN}': `${sitePrefix}.home_pc.footer_social.social_entry_{NN}`,
  },
  footer_subscribe: {
    code: `${sitePrefix}.home_pc.footer_subscribe`,
    email_input: `${sitePrefix}.home_pc.footer_subscribe.email_input`,
    submit_subscription: `${sitePrefix}.home_pc.footer_subscribe.submit_subscription`,
  },
  header_tools: {
    code: `${sitePrefix}.home_pc.header_tools`,
    cart_entry: `${sitePrefix}.home_pc.header_tools.cart_entry`,
    open_account: `${sitePrefix}.home_pc.header_tools.open_account`,
    open_wishlist: `${sitePrefix}.home_pc.header_tools.open_wishlist`,
    search_input: `${sitePrefix}.home_pc.header_tools.search_input`,
    search_submit: `${sitePrefix}.home_pc.header_tools.search_submit`,
  },
  hero_banner: {
    code: `${sitePrefix}.home_pc.{component_id}_{id}`,
    'banner_{NN}': `${sitePrefix}.home_pc.{component_id}_{id}.banner_{NN}`,
    'slide_indicator_{NN}': `${sitePrefix}.home_pc.{component_id}_{id}.slide_indicator_{NN}`,
  },
  new_arrivals: {
    code: `${sitePrefix}.home_pc.{component_id}_{id}`,
    'color_swatch_{NNN}_{NN}': `${sitePrefix}.home_pc.{component_id}_{id}.color_swatch_{NNN}_{NN}`,
    'favorite_{NNN}': `${sitePrefix}.home_pc.{component_id}_{id}.favorite_{NNN}`,
    open_campaign: `${sitePrefix}.home_pc.{component_id}_{id}.open_campaign`,
    'product_{NNN}': `${sitePrefix}.home_pc.{component_id}_{id}.product_{NNN}`,
  },
  primary_navigation: {
    code: `${sitePrefix}.home_pc.primary_navigation`,
    logo_entry: `${sitePrefix}.home_pc.primary_navigation.logo_entry`,
    'nav_item_{NN}': `${sitePrefix}.home_pc.primary_navigation.nav_item_{NN}`,
    scroll_navigation_next: `${sitePrefix}.home_pc.primary_navigation.scroll_navigation_next`,
    scroll_navigation_previous: `${sitePrefix}.home_pc.primary_navigation.scroll_navigation_previous`,
    'submenu_item_{NN}_{NN}': `${sitePrefix}.home_pc.primary_navigation.submenu_item_{NN}_{NN}`,
  },
  service_promises: {
    code: `${sitePrefix}.home_pc.{component_id}_{id}`,
    'service_entry_{NN}': `${sitePrefix}.home_pc.{component_id}_{id}.service_entry_{NN}`,
  },
  shop_by_shapes: {
    code: `${sitePrefix}.home_pc.{component_id}_{id}`,
    next: `${sitePrefix}.home_pc.{component_id}_{id}.next`,
    previous: `${sitePrefix}.home_pc.{component_id}_{id}.previous`,
    'shape_entry_{NN}': `${sitePrefix}.home_pc.{component_id}_{id}.shape_entry_{NN}`,
  },
  shop_by_vibes: {
    code: `${sitePrefix}.home_pc.{component_id}_{id}`,
    'style_entry_{NN}': `${sitePrefix}.home_pc.{component_id}_{id}.style_entry_{NN}`,
  },
  shopping_guide: {
    code: `${sitePrefix}.home_pc.{component_id}_{id}`,
    add_prescription: `${sitePrefix}.home_pc.{component_id}_{id}.add_prescription`,
    after_sales: `${sitePrefix}.home_pc.{component_id}_{id}.after_sales`,
    choose_frames: `${sitePrefix}.home_pc.{component_id}_{id}.choose_frames`,
    customize_lenses: `${sitePrefix}.home_pc.{component_id}_{id}.customize_lenses`,
  },
  site_notice: {
    code: `${sitePrefix}.home_pc.site_notice`,
    open_help_center: `${sitePrefix}.home_pc.site_notice.open_help_center`,
    open_promotion: `${sitePrefix}.home_pc.site_notice.open_promotion`,
    open_site_settings: `${sitePrefix}.home_pc.site_notice.open_site_settings`,
    track_order: `${sitePrefix}.home_pc.site_notice.track_order`,
  },
  site_settings: {
    code: `${sitePrefix}.home_pc.site_settings`,
    'country_option_{NNN}': `${sitePrefix}.home_pc.site_settings.country_option_{NNN}`,
    country_selector: `${sitePrefix}.home_pc.site_settings.country_selector`,
    'currency_option_{NN}': `${sitePrefix}.home_pc.site_settings.currency_option_{NN}`,
    currency_selector: `${sitePrefix}.home_pc.site_settings.currency_selector`,
    'language_option_{NN}': `${sitePrefix}.home_pc.site_settings.language_option_{NN}`,
    language_selector: `${sitePrefix}.home_pc.site_settings.language_selector`,
  },
  style_community: {
    code: `${sitePrefix}.home_pc.{component_id}_{id}`,
    explore_more: `${sitePrefix}.home_pc.{component_id}_{id}.explore_more`,
    next: `${sitePrefix}.home_pc.{component_id}_{id}.next`,
    'open_creator_gallery_{NN}': `${sitePrefix}.home_pc.{component_id}_{id}.open_creator_gallery_{NN}`,
    previous: `${sitePrefix}.home_pc.{component_id}_{id}.previous`,
  },
} as const satisfies SpmPageCodes;
